// styles.js
import { styled } from "@mui/system";

export const Styles = styled("div")(({ theme }) => ({
  ".main-container": {
    paddingInline: "100px",
    [theme.breakpoints.down("lg")]: { paddingInline: "50px" },
    [theme.breakpoints.down("md")]: { paddingInline: "30px" },

    ".logo": {
      width: "160px",
      [theme.breakpoints.down("md")]: { width: "120px" },
      [theme.breakpoints.down("sm")]: { width: "100px" },
    },

    ".links-container": {
      gap: "20px",
      marginRight: "10px",
      display: "flex",
      alignItems: "center",

      // Style for all navigation items
      ".item": {
        fontSize: "10px", // Default for smallest screens
        fontWeight: 500,
        textDecoration: "none",
        position: "relative",
        padding: "5px 0",
        color: "#000",
        display: "inline-flex",
        alignItems: "center",
        height: "100%",
        fontFamily: "inherit",
        lineHeight: "1",

        // For max width 1080px (smaller screens)
        [theme.breakpoints.down(1080)]: {
          fontSize: "12px",
        },

        // For min width 1080px and max width 1980px
        [theme.breakpoints.between(1080, 1580)]: {
          fontSize: "10px",
        },

        // For screens larger than 1980px (optional)
        [theme.breakpoints.up(1580)]: {
          fontSize: "12px", // or whatever you want for very large screens
        },

        // For screens larger than 1980px (optional)
        [theme.breakpoints.up(1910)]: {
          fontSize: "14px", // or whatever you want for very large screens
        },

        "&.active": {
          color: "#4ea27d",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "2px",
            backgroundColor: "#4ea27d",
          }
        }
      },

      // Specific styles for dropdown button to match other tabs
      ".dropdown-button": {
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: "0 !important",
        margin: "0 !important",
        minWidth: "auto !important",
        textTransform: "none !important",
        fontFamily: "inherit !important",
        fontSize: "12px !important", // Default
        fontWeight: "500 !important",
        display: "inline-flex !important",
        alignItems: "center",
        height: "100%",
        lineHeight: "1.5 !important",

        // For max width 1080px
        [theme.breakpoints.down(1080)]: {
          fontSize: "12px !important",
        },

        // For min width 1080px and max width 1980px
        [theme.breakpoints.between(1080, 1980)]: {
          fontSize: "14px !important",
        },

        // For screens larger than 1980px (optional)
        [theme.breakpoints.up(1980)]: {
          fontSize: "16px !important",
        },

        "&:hover": {
          background: "none !important",
        },

        "&.active": {
          color: "#4ea27d !important",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "2px",
            backgroundColor: "#4ea27d",
          }
        }
      },

      [theme.breakpoints.down("md")]: {
        gap: "25px",
        ".item, .dropdown-button": {
          // Remove individual font-size declarations here since we're handling them above
        }
      },

      [theme.breakpoints.down("sm")]: {
        gap: "15px",
        ".item, .dropdown-button": {
          // Remove individual font-size declarations here since we're handling them above
        }
      },

      [theme.breakpoints.down("lg")]: {
        ".item, .dropdown-button": {
          fontWeight: 400,
          // Remove individual font-size declarations here
        }
      },

      /* Hide scrollbar */
      overflowX: "auto",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
}));